import React, { useEffect, useState } from "react";
import { Clock, Search } from "react-bootstrap-icons";
import TournamentCardGrid from "../../components/TournamentCardGrid";
import { getScheduledTournamentsAsync } from "../../utils/api";
import { filterTournamentsBySearch } from "../../utils/helpers";
import { Alert, Button, Form, InputGroup } from "react-bootstrap";

const ScheduledPage = ({ setTitle }) => {
  const [refresh, setRefresh] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  const [state, setState] = useState({
    loading: true,
    tournaments: [],
    error: null,
  });

  setTitle("Scheduled tournaments");

  const fetchData = async (ct) => {
    try {
      const data = await getScheduledTournamentsAsync(ct);
      setState({
        loading: false,
        tournaments: data,
        error: null,
      });
    } catch (error) {
      if (ct?.aborted) return;

      setState((prev) => ({
        ...prev,
        loading: false,
        tournaments: [],
        error: error,
      }));
    }
  };

  useEffect(() => {
    setState((prev) => ({ ...prev, loading: true }));

    const cts = new AbortController();
    fetchData(cts.signal);

    return () => {
      cts.abort();
    };
  }, [refresh]);

  return (
    <div className="scheduled-page">
      <div className="tournament-list-page-header border-bottom mb-3">
        <div className="page-title fs-5">
          <Clock />
          Scheduled tournaments
        </div>
        <div className="tournament-list-page-header-right">
          <InputGroup size="sm">
            <InputGroup.Text>
              <Search />
            </InputGroup.Text>
            <Form.Control
              type="search"
              placeholder="Search…"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="tournament-list-page-header-search"
            />
          </InputGroup>
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={() => setRefresh(refresh + 1)}
          >
            Refresh
          </Button>
        </div>
      </div>

      {state.error ? (
        <Alert variant="danger">Error: {state.error.message}</Alert>
      ) : (
        <TournamentCardGrid
          loading={state.loading}
          tournaments={filterTournamentsBySearch(
            state.tournaments,
            searchQuery,
          )}
        />
      )}
    </div>
  );
};

export default ScheduledPage;
